import React from "react";

export default class Contact extends React.Component {
  render() {
    return (
      <div className="container">
        <h1 className="pageHeader">Contact</h1>
        <p>Contact us anytime, day or night.</p>
      </div>
    );
  }
}
